import React, { Fragment } from 'react'
import { Container, makeStyles } from '@material-ui/core'
import HomeNavbar from '../components/Navbars/home-navbar'
import Login from '../containers/auth/login';
import { Route, Switch } from 'react-router-dom';
import NotFound from '../components/404/not-found';

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
}));

const Auth = () => {
  const classes = useStyles();

  return (
    <Fragment>
      <HomeNavbar />
      <Container maxWidth="lg" className={classes.container}>
        <Switch>
          <Route path="/" exact component={Login} />
          <Route component={NotFound} />
        </Switch>
      </Container>
    </Fragment>
  )
};

export default Auth;
